import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-with-evacuation',
  templateUrl: './help-with-evacuation.component.html',
  styleUrls: ['./help-with-evacuation.component.css'],
})
export class HelpWithEvacuationComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
